function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  opacity: 0.8
},
/*#__PURE__*/
React.createElement("path", {
  d: "M1.12 20h10.2a.492.492 0 100-.984H1.12a.155.155 0 01-.135-.164v-1.027l6.638-3.792.028-.02a.534.534 0 00.044-.032.438.438 0 00.04-.04c.008-.008.016-.014.023-.023v-.006a.547.547 0 00.034-.051l.02-.031c.006-.01.014-.033.021-.05s.011-.026.015-.04a.423.423 0 00.01-.05c0-.014.006-.028.007-.043a.475.475 0 000-.053v-.041c0-.013-.006-.033-.01-.049s-.005-.03-.01-.045l-.016-.04a.512.512 0 00-.022-.05v-.008c-.006-.01-.014-.019-.021-.029l-.031-.043a.467.467 0 00-.038-.038.335.335 0 00-.024-.025C5.454 11.38 5.547 8.032 5.549 7.98v-3.7C5.9 2.336 8.149.985 9.973.985h.038c1.815.018 4.04 1.364 4.387 3.295v3.727c0 .033.156 3.371-2.091 5.222a.356.356 0 00-.025.025s-.007 0-.01.007 0 .007-.007.01a.5.5 0 00-.095.143l-.009.021a.49.49 0 00-.031.163v.022a.477.477 0 00.032.162.215.215 0 00.009.022.467.467 0 00.069.117.238.238 0 00.024.023s0 .009.008.012l1.313 1.312a.495.495 0 00.7-.7l-.95-.947a8.069 8.069 0 002.049-5.644V4.234a.491.491 0 00-.007-.08c-.414-2.486-3.127-4.156-5.4-4.156h-.042C7.67.019 4.988 1.683 4.576 4.153a.56.56 0 00-.006.081v3.724a8.3 8.3 0 001.992 5.549l-6.306 3.6a.492.492 0 00-.248.427v1.312A1.134 1.134 0 001.12 20zM17.996 13.771a1.586 1.586 0 00-1.119.495c-.006.006-.008.014-.013.02s-.012.006-.018.01l-3.369 3.191-.007.007-.019.018a.494.494 0 00-.108.154v.009a.423.423 0 00-.021.05l-.494 1.64a.491.491 0 00.471.633.515.515 0 00.1-.011l1.653-.36a.423.423 0 00.05-.016c.012 0 .023-.007.035-.011a.482.482 0 00.13-.082c.005 0 .012-.006.018-.011l3.466-3.255a.361.361 0 00.024-.034c.008-.007.019-.01.027-.018a1.633 1.633 0 00.544-1.142 1.223 1.223 0 00-.378-.878 1.37 1.37 0 00-.972-.409zm-3.777 4.367l3.3-3.128c.01-.009.014-.022.022-.032s.021-.011.029-.019a.626.626 0 01.422-.2.377.377 0 01.275.123.244.244 0 01.091.181.738.738 0 01-.254.446c-.007.007-.009.016-.016.023s-.011.005-.015.01l-3.365 3.159-.707.154z"
}),
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  d: "M0 0h20v20H0z"
}));

var SvgProfileEdit = function SvgProfileEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgProfileEdit, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/ProfileEdit.43733a30.svg";
export { ForwardRef as ReactComponent };